import { Link, useLocation, useParams } from "react-router-dom";
import { Check } from "lucide-react";
import { formatPrice } from "../lib/format";

export default function OrderConfirmation() {
  const { id } = useParams();
  const order = useLocation().state?.order;

  return (
    <div className="pt-32 pb-24 px-6 md:px-12 min-h-screen">
      <div className="max-w-2xl mx-auto text-center space-y-6">
        <div className="w-16 h-16 mx-auto rounded-full border border-[#C8A97E] flex items-center justify-center">
          <Check size={22} strokeWidth={1.5} className="text-gold" />
        </div>
        <p className="text-xs uppercase tracking-[0.3em] text-gold">Order Confirmed</p>
        <h1 className="font-serif text-4xl md:text-5xl">Thank you</h1>
        <p className="text-muted leading-relaxed">
          Your edit is on its way. A confirmation has been recorded under reference <span className="text-gold tracking-[0.15em]">{id}</span>.
        </p>
        {order && (
          <div className="bg-[#141414] p-8 text-left mt-8">
            <h3 className="text-xs uppercase tracking-[0.25em] text-gold mb-5">Summary</h3>
            <ul className="space-y-3">
              {order.items?.map((i, idx) => (
                <li key={idx} className="flex justify-between text-sm">
                  <span>{i.name} · {i.size} × {i.quantity}</span>
                  <span className="text-gold">{formatPrice(i.price * i.quantity)}</span>
                </li>
              ))}
            </ul>
            <div className="pt-4 mt-4 border-t border-[rgba(244,244,240,0.06)] flex justify-between">
              <span className="text-xs uppercase tracking-[0.2em] text-gold">Total Paid</span>
              <span className="font-serif text-2xl text-gold">{formatPrice(order.total || 0)}</span>
            </div>
            {order.payment?.razorpay_payment_id && (
              <div className="mt-4 pt-4 border-t border-[rgba(244,244,240,0.06)] text-xs text-muted space-y-1">
                <p>Payment ID · <span className="text-text">{order.payment.razorpay_payment_id}</span></p>
                {order.payment.method && <p>Method · <span className="text-text capitalize">{order.payment.method}</span>{order.payment.vpa ? ` · ${order.payment.vpa}` : ""}{order.payment.card_last4 ? ` · ···· ${order.payment.card_last4}` : ""}</p>}
              </div>
            )}
            {order.shiprocket?.ok && (
              <div className="mt-4 pt-4 border-t border-[rgba(244,244,240,0.06)] text-xs text-muted space-y-1">
                <p className="text-gold uppercase tracking-[0.2em]">Shipment</p>
                {order.shiprocket.shiprocket_order_id && <p>Order # · <span className="text-text">{order.shiprocket.shiprocket_order_id}</span></p>}
                {order.shiprocket.awb_code && <p>AWB · <span className="text-text">{order.shiprocket.awb_code}</span></p>}
              </div>
            )}
          </div>
        )}
        <div className="flex gap-4 justify-center pt-4">
          <Link to="/shop" className="btn-outline">Continue Shopping</Link>
          <Link to="/account" className="btn-gold">View Orders</Link>
        </div>
      </div>
    </div>
  );
}
